import { createEntityAdapter } from '@reduxjs/toolkit'

import { RunsheetUnassignedTable } from '../model/runsheet/RunsheetUnassignedTable'

export const runsheetUnassignedTablesAdapter = createEntityAdapter({
  selectId: (table: RunsheetUnassignedTable) => table.runsheetId,
})
